
(function () {

    (function () {
        let w = window,
            ic = w.Intercom;

        if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', intercomSettings);
        } else {
            let d = document,
                i = function () {
                    i.c(arguments)
                };

            i.q = [];
            i.c = function (args) {
                i.q.push(args)
            };
            w.Intercom = i;

            const l = function () {
                let s = d.createElement('script');

                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/ov1kjsvv';
                let x = d.getElementsByTagName('script')[0];

                x.parentNode.insertBefore(s, x);
            };

            if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    })();

})();



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/components/intercom.js